import { z } from 'zod';

export const phoneSchema = z.object({
  ddd: z.string().length(2),
  numero: z.string().min(8).max(9),
});

export const addressSchema = z.object({
  logradouro: z.string().min(1),
  numero: z.string().min(1),
  complemento: z.string().optional(),
  bairro: z.string().min(1),
  cidade: z.string().min(1),
  estado: z.string().length(2),
  cep: z.string().length(8),
});

export const customerSchema = z.object({
  nome: z.string().min(1),
  email: z.email(),
  documento: z.string().min(11).max(14),
  telefone: phoneSchema,
  endereco: addressSchema,
});

// Dados crus do cartão, validados antes da criptografia. Nunca trafegam na rede.
export const creditCardSchema = z.object({
  numero: z.string().length(16),
  validadeMes: z.string().length(2),
  validadeAno: z.string().length(2),
  cvv: z.string().min(3).max(4),
});

export type CreditCard = z.infer<typeof creditCardSchema>;

// Dados do cartão criptografados (RSA) enviados ao gateway: cada campo é `id|<base64>`.
export const encryptedCardSchema = z.object({
  numero: z.string(),
  validadeMes: z.string(),
  validadeAno: z.string(),
  cvv: z.string(),
});

export type EncryptedCard = z.infer<typeof encryptedCardSchema>;

export const paymentRequestSchema = z.object({
  pacoteId: z.number(),
  cupom: z.string().optional(),
  formaPagamento: z.enum(['CARTAO', 'PIX']),
  cliente: customerSchema,
  cartao: encryptedCardSchema.optional(),
});

export type PaymentRequest = z.infer<typeof paymentRequestSchema>;

// Resposta de GET .../api/Cryptography/GetPublicKeyAsync
export const cryptoPublicKeySchema = z.object({
  id: z.string(),
  publicKey: z.string(),
});

export type CryptoPublicKey = z.infer<typeof cryptoPublicKeySchema>;

export const paymentSearchSchema = z.object({
  pacoteId: z.coerce.number().optional(),
  cupom: z.string().optional(),
});

export type PaymentSearch = z.infer<typeof paymentSearchSchema>;

export const productSchema = z.object({
  pacoteId: z.number(),
  cupom: z.string().optional(),
  nomPacote: z.string(),
  parcelas: z.number(),
  valorParcela: z.number(),
  valorTotal: z.number(),
});

export const initCheckoutResponseSchema = z.object({
  pacote: productSchema,
  cliente: customerSchema
    .partial()
    .extend({
      telefone: phoneSchema.partial().optional(),
      endereco: addressSchema.partial().optional(),
    })
    .optional(),
});

export type initCheckoutResponse = z.infer<typeof initCheckoutResponseSchema>;

export const completeCheckoutResponseSchema = z.object({
  transacaoId: z.number(),
});

export type completeCheckoutResponse = z.infer<typeof completeCheckoutResponseSchema>;

export const pixQrCodeResponseSchema = z.object({
  transacaoId: z.number(),
  qrCode: z.string().optional(),
  qrCodeUrl: z.string().optional(),
});

export type PixQrCodeResponse = z.infer<typeof pixQrCodeResponseSchema>;
